export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.eot?3a24a60e7f9c6574864a38814fa07533";